import { render } from "./SupplierTable.vue?vue&type=template&id=4162488a&scoped=true"
import script from "./SupplierTable.vue?vue&type=script&lang=js"
export * from "./SupplierTable.vue?vue&type=script&lang=js"

import "./SupplierTable.vue?vue&type=style&index=0&id=4162488a&lang=stylus&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4162488a"]])

export default __exports__